import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgKonbini({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.718 5.881c.615 0 1.077.513 1.077 1.129v10.05c0 .616-.462 1.129-1.077 1.129H3.488c-.616 0-1.078-.513-1.078-1.128V7.01c0-.616.462-1.129 1.077-1.129h17.23"
        fill="#EF5B2E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.18 13.471H4.46v-.769c.206.052.308.052.718.052h1.693v-1.642H4.513v-.769c.205.052.359.052.718.052h2.41v3.333h-.82v-.257H5.178zM10.051 11.113c-.359-.308-.667-.513-1.18-.821l-.46.615c.41.206.768.462 1.127.872l.513-.666zM9.692 12.6c-.41.154-.872.256-1.282.307l.205.77c.103 0 .154 0 .308-.052.77-.153 1.18-.307 1.64-.615.616-.36.975-.872 1.386-1.692a2.185 2.185 0 01-.616-.564c-.102.307-.256.564-.41.82-.308.513-.718.82-1.23 1.026zM16.03 10.346a2.08 2.08 0 00-.235-.413l-.41.102c.102.137.16.274.216.41.029.069.057.137.091.205l.41-.153a5.823 5.823 0 01-.071-.15zm-.645 1.022l.205-.102-.36-.513.309-.103c-.103-.205-.154-.307-.308-.564l-.41.154a.906.906 0 01.256.41c-.308.257-1.077.565-1.692.667V10.19h-.77v2.82c.052.206.103.36.257.462.205.154.513.205 1.077.205.307 0 .82 0 1.23-.051.257-.051.36-.051.462-.051l-.051-.77c-.192.077-.327.096-.512.123a8.59 8.59 0 00-.206.031c-.257.051-.564.051-.82.051-.36 0-.565-.05-.616-.102-.051-.051-.051-.103-.051-.41v-.462a8.331 8.331 0 002-.667zM16.903 10.517c-.079-.01-.148-.02-.236-.02v.77h2.82v-.77c-.205.051-.359.051-.718.051h-1.436c-.204 0-.325-.016-.43-.03zm.071 2.134c-.41 0-.461 0-.718-.051l-.051.769H19.949v-.77c-.206.052-.36.052-.77.052h-2.205z"
        fill="#fff"
      />
    </svg>
  )
}

export default SvgKonbini
